<div class="fuse-splash-screen">
  <div class="center">
    <div class="logo">
      <img src="assets/images/logos/incase365.svg" alt="incase365 logo" />
      <br />
      <span style="font-weight: bold; color: white; font-size: 24pt;">
        Transport For London Version
      </span>
    </div>
    <!-- Material Design Spinner -->
    <div class="spinner-wrapper">
      <div class="spinner">
        <div class="inner">
          <div class="gap"></div>
          <div class="left">
            <div class="half-circle"></div>
          </div>
          <div class="right">
            <div class="half-circle"></div>
          </div>
        </div>
      </div>
    </div>
    <!-- Material Design Spinner -->
  </div>
</div>